// extracted by mini-css-extract-plugin
export default {"commentIndicatorContainer":"CommentIndicator-module__commentIndicatorContainer--L8lU3"};